import { ApiStatuses } from '../../../../global/models/api-model';

export interface Group {
    name: string;
    group_id: number;
    client_number: string;
}

export interface GroupAnnualEnrollmentStatus {
    effective_date: string,
    first_enrollment_allowed: string,
    group_client_number: string,
    group_id: string,
    group_name: string,
    last_admin_change_allowed: string,
    last_enrollment_allowed: string,
    last_enrollment_allowed_nominal: string,
}

export interface GroupsState {
    groups: Group[];
    currentGroup: Group;
    groupsLoaded: boolean;
    adminAddStatus: ApiStatuses;
    groupAnnualEnrollmentStatus: GroupAnnualEnrollmentStatus;
}

export enum GroupsActionTypes {
    SET_GROUPS = 'SET_GROUPS',
    SET_GROUPS_LOADED = 'SET_GROUPS_LOADED',
    SET_CURRENT_GROUP = 'SET_CURRENT_GROUP',
    SET_GROUP_ANNUAL_ENROLLMENT_STATUS = 'SET_GROUP_ANNUAL_ENROLLMENT_STATUS',
    ADD_ADMIN_STATUS = 'ADD_ADMIN_STATUS',
    CLEAR = 'CLEAR',
}

export enum GroupAdminTypes {
    Junior = 'JuniorGroupPlanAdmin',
    Senior = 'SeniorGroupPlanAdmin',
}
